import { render, staticRenderFns } from "./FormAddressStickersComponent.vue?vue&type=template&id=50c42e01&"
import script from "./FormAddressStickersComponent.vue?vue&type=script&lang=js&"
export * from "./FormAddressStickersComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormAddressStickersComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports